import axios from "axios";
import css from "./index.module.css";
import SEO from "@components/seo";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import InputMask from "react-input-mask";
import { isMobile } from "react-device-detect";

export default function Authorization() {
  const [page, setPage] = useState(0);
  const [phone, setPhone] = useState("");
  const [callId, setCallId] = useState("");
  const [token, setToken] = useState("");
  
  const normalizePhone = (phone: string): string => {
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.startsWith("7")) {
      return "+7" + cleaned.slice(1);
    }
    return "+7" + cleaned;
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const normalizedPhone = normalizePhone(phone);
    formData.set("phone", normalizedPhone);

    axios
      .post(`${import.meta.env.VITE_API_URL}/auth/phone`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setCallId(response.data.id);
        setPage(1);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmitRegistration = (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    axios
      .post(`${import.meta.env.VITE_API_URL}/auth/registration`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((_) => {
        toast.success("Регистрация успешно выполнена");
        localStorage.setItem("authToken", token);
        window.location.replace("/webapp");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (callId && page === 1) {
      const interval = setInterval(() => {
        const normalizedPhone = normalizePhone(phone);
        axios
          .get(
            `${
              import.meta.env.VITE_API_URL
            }/auth/phone/status?callId=${callId}&phone=${normalizedPhone}`,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            if (response.data.code === 1) {
              toast.success("Номер подтвержден, спасибо");

              if (response.data.type == 0) {
                localStorage.setItem("authToken", response.data.token);
                window.location.replace("/webapp");
              } else {
                setPage(2);
                setToken(response.data.token);
              }
            }
          })
          .catch((error) => {
            setCallId("");
            setPage(0);
            toast.error("Ошибка при подтверждении номера");
            console.log(error);
          });
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [callId, page, phone]);

  // const handleCheck = () => {
  //   const normalizedPhone = normalizePhone(phone);
  //   axios
  //     .get(
  //       `${
  //         import.meta.env.VITE_API_URL
  //       }/auth/phone/status?callId=${callId}&phone=${normalizedPhone}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.data.code === 1) {
  //         toast.success("Номер подтвержден, спасибо");

  //         if (response.data.type == 0) {
  //           localStorage.setItem("authToken", response.data.token);
  //           window.location.replace("/webapp");
  //         } else {
  //           setPage(2);
  //           setToken(response.data.token);
  //         }
  //       } else {
  //         toast.info("Ожидаем проверки номера...");
  //       }
  //     })
  //     .catch((error) => {
  //       setCallId("");
  //       setPage(0);
  //       toast.error("Ошибка при подтверждении номера");
  //       console.log(error);
  //     });
  // };

  return (
    <div className={css.container}>
      <SEO
        title="Авторизация"
        description="Авторизация"
        ogUrl="https://рыбныимир.рф"
      />

      <div className={css.component}>
        <div className={css.logoContainer}>
          <img src="/assets/images/icon.png" alt="logo" className={css.logo} />
          <h1>Рыбный мир</h1>
        </div>

        {page === 0 && (
          <form className={css.form} onSubmit={handleSubmit}>
            <a className={css.head}>👋 Добро пожаловать!</a>

            <InputMask
              mask="+7 (999) 999-99-99"
              type="tel"
              placeholder="Введите номер телефона"
              name="phone"
              value={phone}
              onChange={(e: any) => setPhone(e.target.value)}
              required
            />

            <button type="submit">Продолжить</button>
            <span className={css.foot}>
              Продолжая, я соглашаюсь с <a href="/privacy.pdf">политикой обработки персональных</a> данных и <a href="/oferta.pdf">публичной офертой</a>
            </span>
          </form>
        )}

        {page === 1 && (
          <form className={css.form}>
            <a className={css.head}>Выполните звонок на номер</a>
            <a 
              className={css.telephone} 
              href="tel:+74952960000"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = 'tel:+74952960000';
              }}
            >
              <i className="fi fi-rr-circle-phone"></i> +7 495 296-00-00
            </a>
            {isMobile && (
              <button type="button" onClick={(e) => {
                e.preventDefault();
                window.location.href = 'tel:+74952960000';
              }}>
                Позвонить на номер
              </button>
            )}
            {!isMobile && (
              <img
                src="/qr.png"
                alt="qr"
                className={css.qrCode}
                style={{ width: "320px", height: "320px" }}
              />
            )}
            <span className={css.foot}>
              Выполняя звонок, я соглашаюсь с <a href="/privacy.pdf">политикой обработки персональных</a> данных и <a href="/oferta.pdf">публичной офертой</a>
            </span>
          </form>
        )}

        {page === 2 && (
          <form className={css.form} onSubmit={handleSubmitRegistration}>
            <a className={css.head}>Регистрация профиля</a>

            <input
              placeholder="Желаемый логин"
              type="text"
              name="username"
              required
            />
            <input
              placeholder="Как вас зовут?"
              type="text"
              name="firstName"
              required
            />

            <button type="submit">Продолжить</button>
            <span className={css.foot}>
              Продолжая, я соглашаюсь с <a href="/privacy.pdf">политикой обработки персональных</a> данных и <a href="/oferta.pdf">публичной офертой</a>
            </span>
          </form>
        )}

        <a>v2.0</a>
      </div>
    </div>
  );
}
